import { Fragment, useState } from "react";
import {
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Popover,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { downloadBreakout } from "api";

export default function DownloadBreakoutButton(props) {
  const t = props.estatedProperty;
  const [anchorEl, setAnchorEl] = useState(null);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const defaultValues = {
    address: t.address.formatted_street_address,
    city: t.address.city,
    state: t.address.state,
    zipCode: t.address.zip_code,
  };
  const [address, setAddress] = useState(defaultValues.address);
  const [city, setCity] = useState(defaultValues.city);
  const [state, setState] = useState(defaultValues.state);
  const [zipCode, setZipCode] = useState(defaultValues.zipCode);
  const [modalOpen, setModalOpen] = useState(false);
  const download = (type) => {
    if (state === "FL") {
      setAnchorEl(null);
      setModalOpen(true);
      return;
    }
    const addressBody = {
      formatted_street_address: address,
      city,
      state,
      zip_code: zipCode,
    };
    downloadBreakout(t, props.body, addressBody, type).finally(() => {
      setAnchorEl(null);
    });
  };
  return (
    <Fragment>
      <Dialog onClose={() => setModalOpen(false)} open={modalOpen}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          The State of Florida does not allow itemized replacement costs to be
          sent to any party. Please reach out to requesting party to explain
          legal limitations.
        </DialogContent>
      </Dialog>
      <Button
        style={props.style}
        variant="outlined"
        size="small"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        Download
      </Button>
      <IconButton
        style={{ ...props.style, marginRight: 8 }}
        size="small"
        color="primary"
        onClick={(e) => setSettingsAnchorEl(e.currentTarget)}
      >
        <SettingsOutlinedIcon />
      </IconButton>
      <Popover
        open={Boolean(settingsAnchorEl)}
        anchorEl={settingsAnchorEl}
        onClose={() => setSettingsAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column", width: 300 }}
        >
          <Typography variant="h6" color="primary" gutterBottom>
            Download Settings
          </Typography>
          <Grid container spacing={2} pt={2}>
            <Grid item style={{ width: "100%" }}>
              <TextField
                label="Formatted Address"
                value={address}
                style={{ width: "100%" }}
                onChange={(e) => setAddress(e.target.value?.toUpperCase())}
                onBlur={() =>
                  !address ? setAddress(defaultValues.address) : null
                }
              />
            </Grid>
            <Grid item style={{ width: "100%" }}>
              <TextField
                label="City"
                value={city}
                style={{ width: "100%" }}
                onChange={(e) => setCity(e.target.value?.toUpperCase())}
                onBlur={() => (!city ? setCity(defaultValues.city) : null)}
              />
            </Grid>
            <Grid item style={{ width: "100%" }}>
              <TextField
                label="State"
                value={state}
                style={{ width: "100%" }}
                onChange={(e) => setState(e.target.value?.toUpperCase())}
                onBlur={() => (!state ? setState(defaultValues.state) : null)}
              />
            </Grid>
            <Grid item style={{ width: "100%" }}>
              <TextField
                label="Zip Code"
                value={zipCode}
                style={{ width: "100%" }}
                onChange={(e) => setZipCode(e.target.value?.toUpperCase())}
                onBlur={() =>
                  !zipCode ? setZipCode(defaultValues.zipCode) : null
                }
              />
            </Grid>
          </Grid>
        </Paper>
      </Popover>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => download("luxury")}>Luxury</MenuItem>
        <MenuItem onClick={() => download("semi_luxury")}>Semi Luxury</MenuItem>
        <MenuItem onClick={() => download("best_std")}>Best Standard</MenuItem>
        <MenuItem onClick={() => download("good_std")}>Good Standard</MenuItem>
        <MenuItem onClick={() => download("avg_std")}>Avg Standard</MenuItem>
        <MenuItem onClick={() => download("min_std")}>Min Standard</MenuItem>
      </Menu>
    </Fragment>
  );
}
